import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex mb-4 justify-between" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", {
  class: "pi pi-calendar text-base cursor-pointer text-black mr-1",
  "aria:haspopup": "true"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "text-black font-semibold text-sm text-center" }, /*#__PURE__*/_toDisplayString('Range Tanggal'), -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Tanggal : ")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode()
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "chip-red font-semibold inline-block p-2" }, " Pending ", -1)
const _hoisted_12 = {
  class: "flex gap-4",
  style: {"border-left":"1px solid #ECEFF1"}
}
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "mr-2 color-primary font-semibold" }, "Pindah Jadwal", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("i", {
  class: "pi pi-arrow-right text-base color-primary",
  "aria:haspopup": "true"
}, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "pi pi-info-circle text-sm color-blue-grey-darken-1 mr-3"
}
const _hoisted_16 = { class: "p-col-12 block" }
const _hoisted_17 = { class: "btn-action w-full flex justify-end mt-5" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Clear Filter")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxExport = _resolveComponent("DxExport")
  const _component_DxPaging = _resolveComponent("DxPaging")
  const _component_DxPager = _resolveComponent("DxPager")
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")
  const _component_DxColumn = _resolveComponent("DxColumn")
  const _component_DxGroupPanel = _resolveComponent("DxGroupPanel")
  const _component_DxGrouping = _resolveComponent("DxGrouping")
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Button = _resolveComponent("Button")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", {
          class: "filterChips",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDateFilter($event)))
        }, [
          _hoisted_3,
          _hoisted_4
        ])
      ]),
      _createVNode("div", null, [
        _hoisted_5,
        (Array.isArray(_ctx.dateFilter))
          ? (_openBlock(), _createBlock("span", _hoisted_6, [
              (_ctx.dateFilter[0])
                ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.moment(_ctx.dateFilter[0]).format("DD MMMM YYYY")), 1))
                : _createCommentVNode("", true),
              (_ctx.dateFilter[1])
                ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(` - ${_ctx.moment(_ctx.dateFilter[1]).format("DD MMMM YYYY")}`), 1))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createBlock("span", _hoisted_9, [
              _createVNode("span", null, _toDisplayString(_ctx.moment().subtract(3, 'd').format("DD MMMM YYYY")), 1),
              _createVNode("span", null, _toDisplayString(` - ${_ctx.moment().format("DD MMMM YYYY")}`), 1)
            ]))
      ])
    ]),
    _createVNode(_component_DxDataGrid, {
      ref: "refPendingTable",
      class: "receive-item-table",
      id: "pending-table-id",
      "column-auto-width": true,
      "allow-column-reordering": false,
      "show-column-lines": false,
      "show-row-lines": true,
      "show-borders": true,
      "row-alternation-enabled": true,
      "allow-column-resizing": false,
      "word-wrap-enabled": true,
      "data-source": _ctx.data,
      "key-expr": "Id",
      "no-data-text": _ctx.noDataText,
      onExporting: _ctx.exportGrids
    }, {
      "cell-highlighted": _withCtx(({ data }) => [
        _createVNode("div", {
          class: "cursor-pointer",
          onClick: ($event: any) => (_ctx.$emit('showDetail', data.data.Id))
        }, [
          _createVNode("p", null, _toDisplayString(data.data.Resi.toUpperCase()), 1)
        ], 8, ["onClick"])
      ]),
      cellTemplate: _withCtx(() => [
        _hoisted_11
      ]),
      cellAction: _withCtx(({ data }) => [
        _createVNode("div", _hoisted_12, [
          _createVNode("div", {
            class: "flex cursor-pointer ml-3",
            onClick: ($event: any) => (_ctx.onDetail(data.data.Id))
          }, [
            _hoisted_13,
            _hoisted_14
          ], 8, ["onClick"]),
          (data.data.Attribute1)
            ? _withDirectives((_openBlock(), _createBlock("i", _hoisted_15, null, 512)), [
                [
                  _directive_tooltip,
                  data.data.Attribute1,
                  void 0,
                  { bottom: true }
                ]
              ])
            : _createCommentVNode("", true),
          _createVNode("i", {
            class: "pi pi-ellipsis-h text-base cursor-pointer text-black",
            "aria:haspopup": "true",
            "aria-controls": "overlay_panel",
            onClick: ($event: any) => (_ctx.showDropDown($event, data.data))
          }, null, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxExport, {
          enabled: true,
          "allow-export-selected-data": false
        }),
        _createVNode(_component_DxPaging, {
          "page-size": 20,
          enabled: true
        }),
        _createVNode(_component_DxPager, {
          visible: true,
          "allowed-page-sizes": _ctx.pageSizes,
          "display-mode": _ctx.displayMode,
          "show-page-size-selector": _ctx.showPageSizeSelector,
          "show-info": _ctx.showInfo,
          "show-navigation-buttons": _ctx.showNavButtons
        }, null, 8, ["allowed-page-sizes", "display-mode", "show-page-size-selector", "show-info", "show-navigation-buttons"]),
        _hoisted_10,
        _createVNode(_component_DxFilterRow, { visible: _ctx.showFilterRow }, null, 8, ["visible"]),
        _createVNode(_component_DxHeaderFilter, { visible: _ctx.showHeaderFilter }, null, 8, ["visible"]),
        _createVNode(_component_DxColumnChooser, {
          enabled: true,
          mode: "select",
          title: "Pilih Kolom",
          "allow-search": true
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "LastUpdate",
          caption: "Tanggal Pending",
          "min-width": 150,
          alignment: "left",
          "data-type": "date",
          format: "dd-MM-yyyy"
        }),
        _createVNode(_component_DxColumn, {
          alignment: "left",
          "data-field": "Resi",
          caption: "No. Resi",
          "min-width": 200,
          "cell-template": "cell-highlighted"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NamaAgenAsal",
          caption: "Ag. Asal",
          visible: false,
          "min-width": 150
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NamaAgenTujuan",
          caption: "Ag. Tujuan",
          alignment: "left",
          visible: true,
          "min-width": 170
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NamaPengirim",
          caption: "Pengirim",
          "min-width": 150,
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "HpPengirim",
          caption: "No. Pengirim",
          visible: false,
          width: 130
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NamaPenerima",
          caption: "Penerima",
          visible: false,
          "min-width": 150
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "HpPenerima",
          caption: "No. Penerima",
          visible: false,
          width: 130
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "TotalColly",
          caption: "Total Koli",
          "min-width": 100,
          alignment: "left"
        }),
        _createVNode(_component_DxColumn, {
          caption: "Status",
          "cell-template": "cellTemplate",
          "min-width": 150,
          "css-class": "cell-status",
          alignment: "left"
        }),
        _createVNode(_component_DxColumn, {
          "cell-template": "cellAction",
          "min-width": 200,
          "css-class": "cell-status",
          alignment: "left"
        }),
        _createVNode(_component_DxGroupPanel, {
          visible: true,
          "empty-panel-text": "Drag kolom ke sini untuk mengelompokkan menurut kolom tersebut"
        }),
        _createVNode(_component_DxGrouping, {
          "auto-expand-all": _ctx.autoExpandAll,
          "context-menu-enabled": true,
          "expand-mode": "rowClick"
        }, null, 8, ["auto-expand-all"]),
        _createVNode(_component_DxSearchPanel, { visible: true })
      ]),
      _: 1
    }, 8, ["data-source", "no-data-text", "onExporting"]),
    _createVNode(_component_DxLoadPanel, {
      "close-on-outside-click": false,
      visible: _ctx.loading,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.loading = $event)),
      position: _ctx.position,
      shading: true,
      "shading-color": "rgba(0,0,0,0.4)"
    }, null, 8, ["visible", "position"]),
    _createVNode(_component_OverlayPanel, {
      ref: "op",
      id: "overlay_panel"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          refund: _ctx.route.name === 'transaksi-pengiriman-pending' ? _ctx.route.meta.permission.update && _ctx.$checkIsRefund(_ctx.dataForm.TransPengirimanDetails) : _ctx.$checkIsRefund(_ctx.dataForm.TransPengirimanDetails),
          detail: true,
          onRefund: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refund(_ctx.dataForm.Id))),
          onDetail: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('showDetail', _ctx.dataForm.Id)))
        }, null, 8, ["refund"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_OverlayPanel, {
      ref: "dateOp",
      id: "filter_overlay_panel",
      class: "p-5"
    }, {
      default: _withCtx(() => [
        _createVNode("span", _hoisted_16, [
          _createVNode(_component_Calendar, {
            modelValue: _ctx.dateFilter,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dateFilter = $event)),
            inline: true,
            showWeek: true,
            selectionMode: 'range'
          }, null, 8, ["modelValue"]),
          _createVNode("div", _hoisted_17, [
            (_ctx.dateFilter)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Filter",
                  class: "font-semibold p-button-sm btn-primary px-10 mr-2",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.saveFilterDate()))
                }))
              : _createCommentVNode("", true),
            (_ctx.dateFilter)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "btn-secondary text-black p-button-sm px-10 py-1",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearFilterDate()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}